<template>
    <el-card shadow="never" class="aui-card--fill">
      <vxe-toolbar ref="xToolbar" custom>
        <template v-slot:buttons>
          <el-form
            :inline="true"
            :model="queryForm"
            @keyup.enter.native="getDataList()"
            ref="queryForm"
            class="query-form"
          >
            <el-form-item prop="sellerName" label="外销合同号：">
              <el-input
                v-model="queryForm.orderCode"
                size="mini"
                clearable
                type="text"
                placeholder="请输入外销合同号"
              ></el-input>
            </el-form-item>
            <el-form-item prop="storeName" label="仓库：">
              <el-input
                v-model="queryForm.storeName"
                size="mini"
                clearable
                type="text"
                placeholder="请输入仓库名称"
              ></el-input>
            </el-form-item>
            <el-form-item prop="storeType" label="操作类型：">
                <el-select v-model="queryForm.storeType" size="mini" clearable>
                <el-option :value="1" label="入库"></el-option>
                <el-option :value="-1" label="出库"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item prop="productName" label="品名：">
              <el-input
                v-model="queryForm.productName"
                size="mini"
                clearable
                type="text"
                placeholder="请输入品番号/品名/颜色/规格/幅宽/克重"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="getDataList" size="mini"
                >查询</el-button
              >
              <el-button @click="reset" size="mini">重置</el-button>
            </el-form-item>
          </el-form>
        </template>
      </vxe-toolbar>
      <vxe-table
        align="center"
        :id="tableConfig.id"
        :ref="tableConfig.tableName"
        show-overflow
        row-id="id"
        :height="tableConfig.height"
        :loading="tableData.loading"
        :data="tableData.dataList"
        border="full"
        :cell-style="cellStyleHandler"
        :custom-config="tableConfig.customConfig"
        @resizable-change="resizableChangeEvent"
      >
        <vxe-column type="seq" title="行号" width="50"></vxe-column>
        <vxe-column
          field="agreementCode"
          title="合同编号"
          min-width="160"
          :formatter="companyNameFormatter"
        ></vxe-column>
        <vxe-column
            field="senderName"
            title="供应商"
            :formatter="companyNameFormatter"
            min-width="160"
        ></vxe-column>
        <vxe-column
          field="storageName"
          title="仓库名称"
          :formatter="companyNameFormatter"
          min-width="160"
        ></vxe-column>
        <el-table-column
            prop="receiptCode"
            label="发票号"
            header-align="center"
            align="center"
        ></el-table-column>
        <vxe-column field="productName" title="品名" min-width="90"></vxe-column>
        <vxe-column field="color" title="颜色" min-width="90"></vxe-column>
        <vxe-column field="size" title="规格" min-width="90"></vxe-column>
        <vxe-column field="attr1" title="幅宽" min-width="90"></vxe-column>
        <vxe-column field="attr2" title="克重" min-width="90"></vxe-column>
        <vxe-column
        title="出入库类型"
            width="90"
        >
          <template #default="{row}">
            <div style="color:#67C23A;" v-if="row.type === 1">
              入库
            </div>
            <div style="color:#F56C6C;" v-else-if="row.type === -1">
              出库
            </div>
          </template>
        </vxe-column>
        <vxe-column field="count" title="数量" min-width="90" fixed="right">
            <template #default="{row}">
            <div style="color:#67C23A;" v-if="row.type === 1">
              {{ row.count }}
            </div>
            <div style="color:#F56C6C;" v-else-if="row.type === -1">
              {{ row.count }}
            </div>
          </template>
        </vxe-column>
        <vxe-column field="price" title="收货价格" min-width="90"></vxe-column>
        <vxe-column field="operateTime" title="出入库日期" min-width="90"></vxe-column>
        <vxe-column title="图片" min-width="90">
          <template #default="{row}">
            <img-viewer :imgs="row.imgs" ></img-viewer>
          </template>
        </vxe-column>
        <vxe-column  title="操作" min-width="90">
          <template #default="{row}">
            <el-button
                v-if="$hasPermission('trade:factorystorelog:update')"
                type="text"
                size="small"
                @click="showUpdateDialog(scope.row)"
            >修改
            </el-button
            >
            <el-button
                v-if="$hasPermission('store:log:delete')"
                type="text"
                size="small"
                @click="deleteHandle(scope.row.id)"
            >删除
            </el-button
            >
          </template>
        </vxe-column>
      </vxe-table>
      <vxe-pager
        :loading="tableData.loading"
        :current-page="tableData.currentPage"
        :page-size="pagerConfig.pageSize"
        :total="tableData.total"
        :layouts="pagerConfig.layouts"
        @page-change="vxePageChanger"
      >
      </vxe-pager>
    </el-card>
  </template>

  <script>
  import VxeTable from "@/mixins/vxe-table";
  import ImgViewer from '@/components/ImgViewer'
  export default {
    mixins: [VxeTable],
    components: {ImgViewer,ChangeLogDialog},
    data() {
      return {
        tableConfig: {
          queryUrl: "/trade/factorystorelog/page",
          deleteURL:'/store'
        },
        queryForm: {
          productType: "原料",
          productName: "",
          orderCode: "",
          storeName: "",
          storeType:''
        },
      };
    },
    watch: {},
    computed: {},
    methods: {
    },
  };
  </script>

  <style scoped></style>
